import React, { useContext, useMemo, useEffect } from 'react';
import KonteringManagerQuery from './Query/KonteringManagerQuery';
import { KodplanContext } from '../../../../../Components/KodplanManager/Context/KodplanContext';
import { KonteringUtils } from './KonteringManagerUtils';
import { KonteringContextProvider } from './KonteringContext';
import { getTodaysKodplan } from '../../../../../Components/KodplanManager/KodplanManager';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { FieldValidationType } from '../BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';

interface IProps {}

export interface IKonteringValidationError {
  kontodel: string;
  lopnr: number;
  meddelande: string;
  type: FieldValidationType;
  showAsHint?: boolean;
}

export interface IKodstrang {
  id: string;
  belopp: number;
  kontodelar: IKodstrangDel[];
}

export interface IKodstrangDel {
  id: string;
  kontodel: string; // '4530'
  ordningsNr: number;
  benamning: string;
}

/**
 Innehåller funktioner för att validera en kontering
 * - Konteringen ligger innanför användarens kodbehörigheter
 * - Konteringen uppfyller kombinationsvillkor
 */
const KonteringManager: React.FC<React.PropsWithChildren<IProps>> = props => {
  const kodplanContext = useContext(KodplanContext);
  const { activeDatabase } = useContext(ActiveDatabaseContext);

  return (
    // TODO:LR ta bort och gör om till en usequery i denna komponenten för att slippa köra hooks i renderingen
    <KonteringManagerQuery>
      {({
        bokforingsAr,
        kontoplaner,
        getKontoplan,
        attestKodbehUrval,
        loading,
        konteringsvarden,
        kontodelkombinationer,
      }) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (
            !kodplanContext.loading &&
            kodplanContext.availableKodplanList.length > 0 &&
            getTodaysKodplan(kodplanContext.availableKodplanList)?.id &&
            activeDatabase
          ) {
            getKontoplan({
              variables: {
                kodplanId:
                  getTodaysKodplan(kodplanContext.availableKodplanList)?.id ??
                  '',
                dbName: activeDatabase ?? '',
              },
            });
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [kodplanContext, activeDatabase]);

        // eslint-disable-next-line react-hooks/rules-of-hooks
        const konteringUtils: KonteringUtils = useMemo(() => {
          const newKonteringUtils = new KonteringUtils(
            kontoplaner,
            getKontoplan,
            activeDatabase ?? '',
            konteringsvarden,
            kontodelkombinationer
          );
          return newKonteringUtils;
        }, [
          kontoplaner,
          getKontoplan,
          konteringsvarden,
          kontodelkombinationer,
        ]);

        return (
          <KonteringContextProvider
            value={{
              bokforingsAr,
              konteringUtils,
              konteringValidationQueryLoading: Boolean(loading),
              attestKodbehorigheterUrval: attestKodbehUrval,
            }}
          >
            {props.children}
          </KonteringContextProvider>
        );
      }}
    </KonteringManagerQuery>
  );
};

export default KonteringManager;
